export const iconFontAwesomeMedicalHealthVirusCovid = (
	<i className="fa-solid fa-virus-covid"></i>
);
